export const formatAudioDuration = (durationSeconds) => {
  const safeDuration = Number.isFinite(durationSeconds) ? durationSeconds : 0;
  const totalSeconds = Math.max(0, Math.floor(safeDuration));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

export default formatAudioDuration;
